/// <amd-module name="Build/DesignerExtensions/ExclusiveLockCheckPanel/Components/ExclusiveLockWrapperComponent" />
import * as React from "react";

import { ExclusiveLockCheckComponent } from "Build/DesignerExtensions/ExclusiveLockCheckPanel/Components/ExclusiveLockCheckComponent";
import * as Resources from "Build/DesignerExtensions/ExclusiveLockCheckPanel/Resources";
import { CheckAction, ChecksTableCellRenderer, ICheckWrapperComponentProps } from "Checks/Client/Contracts/Contracts";
import { CheckConfiguration } from "Checks/Client/Contracts/PipelinesChecks";

import { ResourceLockData } from "Build/DesignerExtensions/ExclusiveLockCheckPanel/Client/Contracts/DistributedTask/Checks";
import * as Constants from "Build/DesignerExtensions/ExclusiveLockCheckPanel/Constants";
import { equals } from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

import { Tooltip } from "VSSUI/TooltipEx";

interface ExclusiveLockState {
    inUse: boolean;
    build: string | undefined;
}

export class ExclusiveLockWrapperComponent extends VssComponent<ICheckWrapperComponentProps, ExclusiveLockState> {

    private _deployOnceCheckConfiguration: CheckConfiguration;
    private _pageContext: IVssPageContext;

    public constructor(props: ICheckWrapperComponentProps, context: IVssComponentContext) {
        super(props, context);
        this._pageContext = context.pageContext;

        this.state = {build: undefined, inUse: false};
    }

    public componentDidMount() {
        if (this.props.checkTableCellToRender !== undefined && this.props.checkConfigObject) {
            let contributionService = this._pageContext.getService<IVssContributionService>("IVssContributionService");
            var query = {resourceId: this.props.checkConfigObject.resource.id, resourceType: this.props.checkConfigObject.resource.type};
            contributionService.getDataAsync<ResourceLockData>(Constants.ExclusiveLockDataProvider, query).then((data) => {
                if (data != null) {
                    this.setState({
                        build: data.definition,
                        inUse: data.isInUse
                    });
                }
            });
        }
    }

    public render(): JSX.Element {
        if (this.props.checkConfigObject) {
            this._deployOnceCheckConfiguration = this.props.checkConfigObject as CheckConfiguration;
            if (!equals(this._deployOnceCheckConfiguration.type.id, Constants.ExclusiveLockPolicyTypeIdString, true)) {
                return <div />;
            }
        }

        if (this.props.checkTableCellToRender !== undefined && this.props.checkConfigObject) {
            return this.renderCheckTableCell(this.props.checkTableCellToRender);
        }
        else if (this.props.checkAction === CheckAction.Create) {
            return (
                <ExclusiveLockCheckComponent
                    checkAction={this.props.checkAction}
                    timeout={60 * 24 * 30}
                    {
                        ...this._getCommonProps()
                    } />
            );
        }
        else if (this.props.checkAction === CheckAction.Edit) {
            return (
                <ExclusiveLockCheckComponent
                    checkAction={this.props.checkAction}
                    timeout={this._deployOnceCheckConfiguration.timeout}
                    {
                        ...this._getCommonProps()
                    }
                />
            );
        }
        return <div />;
    }

    private renderCheckTableCell(checkTableCell: ChecksTableCellRenderer): JSX.Element {
        switch (checkTableCell) {
            case ChecksTableCellRenderer.DisplayName:
                return this._renderDisplayNameCell();
            case ChecksTableCellRenderer.Details:
                return this._renderDetailsCell();
            default:
                return <div />;
        }
    }

    private _renderDisplayNameCell(): JSX.Element {
        let displayName = Resources.ExclusiveLockDisplay;
        return (
            <Tooltip text={displayName}>
                <div className="body-m primary-text">
                    {displayName}
                </div>
            </Tooltip>
        );
    }

    private _renderDetailsCell(): JSX.Element {
        return (
            <div className="list-content flex-column flex-grow scroll-hidden">
                <div className="flex-row flex-grow flex-center">
                    <span className="body-m text-ellipsis">{this.state.inUse ? Resources.LockInUse : Resources.LockNotInUse}</span>
                </div>
                {this.state.build && <span className="body-s secondary-text">{this.state.build}</span>}
            </div>
        );
    }

    private _getCommonProps = () => {
        return ({
            resource: this.props.resource,
            disableCreateButton: this.props.disableCreateButton ? this.props.disableCreateButton : () => { },
            updateCheckDataAndEnableSave: this.props.updateCheckDataAndEnableSave ? this.props.updateCheckDataAndEnableSave : () => { },
            updateTelemetryData: this.props.updateTelemetryData ? this.props.updateTelemetryData : () => {}
        });
    }
}
Components.add("exclusive-lock-check-view", ExclusiveLockWrapperComponent);
